<div class="empty-state" [@fadeIn] [ngClass]="'size-' + size">
  <img class="illustration" [ngClass]="'size-' + size" [sgInlineSvg]="effectiveImagePath" [alt]="variantToAlt[variant] || 'Empty state'" />
  <sg-text class="title" [ngClass]="'size-' + size" [variant]="sizeToTitleVariant[size]">{{ title || variantToTitle[variant] }}</sg-text>
  @if (message !== null) {
    <sg-text class="description" [ngClass]="'size-' + size" [variant]="sizeToDescriptionVariant[size]">
      @if (!effectiveMessageHtml) {
        <span>{{ message || variantToMessage[variant] }}</span>
      } @else {
        <span [innerHTML]="effectiveMessageHtml"></span>
      }
    </sg-text>
  }
  @if (submitButtonText || submitCancelButtonText) {
    <div class="buttons" [ngClass]="'size-' + size">
      @if (submitCancelButtonText) {
        <sg-button
          class="cancel-button"
          [size]="size"
          [text]="submitCancelButtonText"
          [variant]="cancelButtonVariant"
          [icon]="cancelButtonIcon ?? ''"
          [iconPosition]="'start'"
          (onClick)="cancel.emit()"
          data-test="empty-state-cancel-button"></sg-button>
      }
      @if (submitButtonText) {
        <sg-button
          class="submit-button"
          [variant]="submitButtonVariant"
          [size]="size"
          [text]="submitButtonText"
          [icon]="submitButtonIcon ?? ''"
          [iconPosition]="'start'"
          [disabled]="submitButtonDisabled"
          [disabledInteractive]="submitButtonDisabled"
          [sgTooltip]="submitButtonTooltip"
          [description]="submitButtonTooltip"
          (onClick)="submit.emit()"
          data-test="empty-state-submit-button"></sg-button>
      }
    </div>
  }
</div>
